var _typeof = require("/home/vsts/work/1/s/Source/ROI/Client/node_modules/@babel/runtime/helpers/typeof");
module.exports = function (it) {
  return _typeof(it) === 'object' ? it !== null : typeof it === 'function';
};